import api from "./api";
import qsStringify from "./qsStringify";

export const getArchiveList = (locale, url) => {
  const query = qsStringify({
    locale,
    pagination: {
      page: 1,
      pageSize: 1000,
    },
  });
  const endpoint = url.includes("tender")
    ? "/api-tenders-archives"
    : "/api-archives";
  return api.get(`${endpoint}?${query}`).then(res => res.data);
};
